









import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';

@Component({
  components: {
    LoadingAnimation,
  },
  computed: {},
})
export default class ReferralButton extends Vue {
  @Prop() text!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) loading!: boolean;

  private handleClick(): void {
    this.$emit('button-clicked');
  }
}
